import { Flex } from "antd";

// A student-only action bar: risky entry separated, ordinary actions right aligned.
export function StudentActions({ danger, children, className = "" }) {
  return <Flex wrap gap={16} align="center" className={`student-action-bar ${className}`}>
    {danger && <Flex gap={8} className="student-action-danger">{danger}</Flex>}
    <Flex wrap gap={8} justify="flex-end" className="student-action-main">{children}</Flex>
  </Flex>;
}
